import TmapGeocoder from "../viewer/tmap/TmapGeocoder";
import DaumPostcode from "../widgets/DaumPostcode";

const FactoryRow = ({
  row,
  idx,
  newCompany,
  setFactoryRows,
  onChangeFactoryRow,
  removeFactoryRow,
  isModal = false,
}) => {
  return (
    <div className="grid grid-cols-2 gap-2 bg-gray-50 border rounded p-2">
      <div>
        <input
          type="text"
          // placeholder={`공장명 * #${idx + 1}`}
          placeholder="공장명"
          value={row.name}
          onChange={(e) => onChangeFactoryRow(idx, "name", e.target.value)}
          className="border rounded px-3 py-2 w-full"
        />

        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id={`copyAddress-${idx}`}
            checked={row.useCopyAddress}
            onChange={(e) => {
              const checked = e.target.checked;
              if (isModal) {
                // 모달에서는 단일 객체 업데이트
                setFactoryRows((prev) => ({
                  ...prev,
                  useCopyAddress: checked,
                  useSearch: false,
                  address: checked ? newCompany.address : "",
                  detail_address: checked ? newCompany.detail_address : "",
                  extra_address: checked ? newCompany.extra_address : "",
                }));
              } else {
                // 일반적인 경우는 배열 업데이트
                setFactoryRows((prev) =>
                  prev.map((r, i) =>
                    i === idx
                      ? {
                          ...r,
                          useCopyAddress: checked,
                          useSearch: false,
                          address: checked ? newCompany.address : "",
                          detail_address: checked ? newCompany.detail_address : "",
                          extra_address: checked ? newCompany.extra_address : "",
                        }
                      : r
                  )
                );
              }
            }}
          />
          <label htmlFor={`copyAddress-${idx}`}>본사 주소와 동일</label>
        </div>

        {!row.useCopyAddress && (
          <DaumPostcode
            text="공장 주소 검색"
            address={row.address}
            extraAddress={row.extra_address}
            onAddressChange={(data) => {
              onChangeFactoryRow(idx, "address", data.address);
              onChangeFactoryRow(idx, "detail_address", data.detail_address);
              onChangeFactoryRow(idx, "extra_address", data.extra_address);
              if (isModal) {
                // 모달에서는 단일 객체 업데이트
                setFactoryRows((prev) => ({ ...prev, useSearch: false }));
              } else {
                // 일반적인 경우는 배열 업데이트
                setFactoryRows((prev) =>
                  prev.map((r, i) =>
                    i === idx ? { ...r, useSearch: false } : r
                  )
                );
              }
            }}
          />
        )}

        <input
          className="border rounded px-3 py-2 w-full"
          type="text"
          placeholder="주소(선택)"
          value={row.address}
          onChange={(e) => onChangeFactoryRow(idx, "address", e.target.value)}
          readOnly
        />
        <input
          className="border rounded px-3 py-2 w-full"
          type="text"
          placeholder="참고 주소(선택)"
          value={row.extra_address}
          onChange={(e) => onChangeFactoryRow(idx, "extra_address", e.target.value)}
          readOnly
        />
        <input
          className="border rounded px-3 py-2 w-full"
          type="text"
          placeholder="상세 주소(선택)"
          value={row.detail_address}
          onChange={(e) => onChangeFactoryRow(idx, "detail_address", e.target.value)}
          readOnly={row.useCopyAddress}
        />

        {!isModal && (
          <button
            type="button"
            onClick={() => removeFactoryRow(idx)}
            className="bg-gray-400 hover:bg-gray-500 text-white px-3 py-2 my-1 rounded float-right"
          >
            삭제
          </button>
        )}
      </div>

      <div className="grid grid-rows-[auto,auto] gap-2">
        <TmapGeocoder
          address={row.address}
          onGeocode={({ lat, lon }) => {
            onChangeFactoryRow(idx, "lat_coord", parseFloat(lat));
            onChangeFactoryRow(idx, "lon_coord", parseFloat(lon));
          }}
          mapId={`map_div_${idx}`}
        />
      </div>
    </div>
  );
};

export default FactoryRow;